import { SegmentServiceModule } from 'services/tracking/segment/segment.service';

export const AnalyticsClickEventDirectiveModule = angular
    .module('app.directives.analyticsClickEvent', [SegmentServiceModule])
    .directive('analyticsClickEvent', ($window, segmentService, $timeout) => {
        return {
            restrict: 'A',
            link: (scope, element, attrs) => {
                let gtmEvent = () => {
                    $timeout(() => segmentService.trackGtmEvent(attrs, {}));
                };
                element.on('click touchstart', gtmEvent);
                scope.$on('$destroy', () => {
                    element.off('click touchstart', gtmEvent);
                });
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/directives/analyticsClickEvent.directive.js